export default __webpack_public_path__ + "static/media/time-to-care-best-match-star.12fbe78f.svg";